import React, { useCallback, FC } from "react";
import { MuiThemeProvider, useTheme } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import ListItem from "@material-ui/core/ListItem";
import Box from "@material-ui/core/Box";
import { makeContext } from "../providers/make";
import Brightness3Icon from "@material-ui/icons/Brightness3";
import Brightness4Icon from "@material-ui/icons/Brightness4";
import { dark } from "./dark";
import { light } from "./light";
import { Typography } from "@material-ui/core";

const key = "theme-type";
export const { Provider: ThemeTypeProvider, useContext: useThemeTypeContext } = makeContext(
  key,
  localStorage.getItem(key) || "light"
);

export const useThemeType = () => useThemeTypeContext()[0];
export const useSetThemeType = () => {
  const setTheme = useThemeTypeContext()[1];
  return useCallback(
    (type: string) => {
      setTheme(type);
      localStorage.setItem(key, type);
    },
    [setTheme]
  );
};

export const ThemeProvider: FC = ({ children }) => {
  const type = useThemeType();
  return <MuiThemeProvider theme={type === "light" ? light : dark}>{children}</MuiThemeProvider>;
};

export const ThemeSwitch = () => {
  const theme = useTheme();
  const type = useThemeType();
  const setTheme = useSetThemeType();
  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <Box>
        <Switch
          checked={type === "light"}
          icon={
            <Box
              borderRadius={20}
              width={20}
              height={20}
              bgcolor={theme.palette.primary.main}
              color="#333"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Brightness3Icon color="inherit" style={{ fontSize: 16 }} />
            </Box>
          }
          checkedIcon={
            <Box
              borderRadius={20}
              width={20}
              height={20}
              bgcolor={theme.palette.primary.main}
              color="#fff"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Brightness4Icon color="inherit" style={{ fontSize: 16 }} />
            </Box>
          }
          onChange={(ev, checked) => setTheme(checked ? "light" : "dark")}
        />
      </Box>
      <Typography color="textPrimary" onClick={() => setTheme(type === "dark" ? "light" : "dark")} variant="subtitle2">
        {type === "dark" ? "Dark Mode" : "Light Mode"}
      </Typography>
    </Box>
  );
};

export const ThemeSwitchItem = () => {
  const theme = useThemeType();
  const setTheme = useSetThemeType();
  return (
    <ListItem button onClick={() => setTheme(theme === "dark" ? "light" : "dark")}>
      <ThemeSwitch />
    </ListItem>
  );
};
